import authHeader from "@/services/auth-header";

const axios = require('axios');
const API_URL='https://www.dev.ekhonidaktar.com/api';

class FetchDoctorService {

    fetchActiveDoctor(){
        return axios.get(`${API_URL}/doctors/active`, {headers: authHeader()});
    }

    fetchActiveDoctorByDoctortype(doctortype){
        return axios.get(`${API_URL}/doctortypes/${doctortype}/doctor/active`, {headers: authHeader()});
    }

}

export default new FetchDoctorService();